import React, {useContext, useState} from 'react';
import phoneCallSVG from "../images/phone-call.svg";
import userSVG from "../images/user.svg";
import logoutSVG from "../images/logout.svg";
import '../sass/TopBarRightSection.sass'
import {AuthContext} from "../../../../context/AuthContext";
import {roleIdToString} from "../../../../utils/roleIdToString";

function TopBarRightSection(props) {
    const {logout, roleId, userName} = useContext(AuthContext)
    return (
        <div className={'top-bar__right-section'}>
            <div className="phone">
                <div className="call-phone">
                    <img src={phoneCallSVG} alt=""/>
                </div>
                <div className="call-number">
                    <div className="num">+7 (843) 212-24-09</div>
                    <a href="tel:+7 (843) 212-24-09">
                        <button>Позвонить нам</button>
                    </a>
                </div>
            </div>

            <User userName={userName} roleId={roleId}/>
            <div onClick={() => {
                logout()
                window.location.href = window.location.origin
            }} className="logout">
                <img src={logoutSVG} alt="logout"/>
            </div>
        </div>
    );
}


function User({userName, roleId}) {
    const [modalVisibility, setModalVisibility] = useState(false)
    return (
        <div style={{position: 'relative'}}>
            <div onMouseEnter={_ => setModalVisibility(true)} onMouseLeave={_ => setModalVisibility(false)}
                 className="user">
                <img src={userSVG} alt="user"/>
            </div>

            {
                modalVisibility && userName &&
                <div style={{
                    background: 'white',
                    width: '250px',
                    right: '0',
                    position: 'absolute',
                    top: '102%',
                    borderRadius: '10px',
                    color: 'black',
                    padding: '20px',
                    boxShadow: '0 3px 6px 0 rgba(39, 45, 59, 0.2)'

                }}>
                    {roleIdToString(roleId)}
                    <br/>
                    <span style={{fontWeight: 'normal'}}>{userName}</span>
                </div>

            }
        </div>
    )

}

export default TopBarRightSection;